module.exports = __webpack_public_path__ + "static/media/InfoIcon.b74c4a37.svg";